import type { PickupScheduleSlot } from '@/services/innovorder/restaurant/restaurant.type';
import { WeekDay } from '@/services/innovorder/restaurant/restaurant.type';

const DAY_INDEX_TO_WEEKDAY: WeekDay[] = [
    WeekDay.SUN,
    WeekDay.MON,
    WeekDay.TUE,
    WeekDay.WED,
    WeekDay.THU,
    WeekDay.FRI,
    WeekDay.SAT,
];

export const isInServiceHours = (schedules: PickupScheduleSlot[]): boolean => {
    if (!schedules || schedules.length === 0) return false;

    const now = new Date();
    const currentDay = DAY_INDEX_TO_WEEKDAY[now.getDay()];
    const currentMinutes = now.getHours() * 60 + now.getMinutes();

    const todaySchedules = schedules.filter((schedule) => schedule.day === currentDay);

    return todaySchedules.some((schedule) => currentMinutes >= schedule.start && currentMinutes <= schedule.end);
};
